module.exports = __webpack_public_path__ + "static/media/ms.bcc70c7e.svg";